import { useContent } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Tooltip } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { WarningOutlineIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

import * as styles from './EventStatus.css';

export const EventDeletedIcon = () => {
  const hasDeletedEventStateDisplayFeature = useUserHasFeature(
    Feature.DeletedEventStateDisplay
  );

  const deletedText = useContent(ContentId.Deleted);

  if (!hasDeletedEventStateDisplayFeature) {
    return null;
  }

  return (
    <Tooltip
      align="center"
      triggerContent={
        <div>
          <WarningOutlineIcon
            fill={vars.color.textError}
            className={styles.eventDisplayIcon}
          />
        </div>
      }
    >
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'unset',
          textOverflow: 'unset',
          minWidth: 'fit-content',
        }}
      >
        {deletedText}
      </div>
    </Tooltip>
  );
};
